import cx from "classnames";
import { FlexBox } from "components";
import React from "react";
import "./styles.scss";
import { DocsFlexSectionBlockProps } from "./types";
const DocsFlexSectionBlock: React.FC<DocsFlexSectionBlockProps> = ({
  className,
  leftSection,
  rightSection,
}) => {
  return (
    <FlexBox
      justifyBetween
      flexWrap
      className={cx(className, "pos-rel code-section")}
    >
      <div className="w-50">{leftSection}</div>
      <div className="w-47">
        <div className="request-response">{rightSection}</div>
      </div>
    </FlexBox>
  );
};
export default DocsFlexSectionBlock;
